"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _styles = _interopRequireDefault(require("./styles.scss"));
var CLASS_NAME = _styles.default['radio-btn-container'];

// Render Radio button
var RadioButton = function RadioButton(props) {
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.ControlLabel, {
    className: "".concat(CLASS_NAME, " ").concat(props.className),
    disabled: props.disabled
  }, /*#__PURE__*/_react.default.createElement("input", {
    id: props.id,
    checked: props.checked,
    type: "radio",
    name: props.name,
    value: props.value,
    onChange: props.onChange,
    disabled: props.disabled
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "radio-circle-round"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "radio-label"
  }, props.label)));
};
RadioButton.propTypes = {
  label: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]),
  className: _propTypes.default.string,
  checked: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  name: _propTypes.default.string,
  value: _propTypes.default.string,
  id: _propTypes.default.string,
  disabled: _propTypes.default.bool
};
RadioButton.defaultProps = {
  label: '',
  className: '',
  checked: false,
  onChange: undefined,
  name: '',
  value: '',
  id: null,
  disabled: false
};
var _default = RadioButton;
exports.default = _default;